import { Component, OnInit } from '@angular/core';
import { CheckoutService } from '../checkout/service/checkout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../_services/notification.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private checkoutService: CheckoutService, private fb: FormBuilder, private notifyService: NotificationService) { }

     contactForm!: FormGroup;

  ngOnInit(): void {

    this.contactForm = this.fb.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            subject: [''],
            mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
            message: ['', [Validators.required]],
        });
  }


   onSubmit(): void {
        if (this.contactForm.valid) {
           const allDataToSend = { name: this.contactForm.value.name, EmailAddress: this.contactForm.value.email, message: this.contactForm.value.message, mobile: this.contactForm.value.mobile };
      this.checkoutService.sendContact(allDataToSend).subscribe(res => {
      debugger;
      if (res.success == true) {
        this.contactForm.reset();
         this.notifyService.showSuccess(
  "Thank you for reaching out! We have received your message and will get back to you shortly.",
  "Message Sent Successfully"
);
      }
    })
            // Call your service to send the form data
        } else {
            console.log('Form is invalid');
            this.contactForm.markAllAsTouched(); // Mark all fields as touched to show validation errors
        }
    }


  contactUs()
  {
   
  }

}
